// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__E13kt","medias":"Footer_medias__1eikK","ibama":"Footer_ibama__HG2uC","links":"Footer_links__YBiSi","copyright":"Footer_copyright__JmfUb"};